import apiClient from "./client";
import type { Streak, StreakGoalUpdate } from "@/types";

/**
 * Streak / daily progress API.
 * Backend: GET /streaks/me, PATCH /streaks/me
 */

export async function getMyStreak(): Promise<Streak> {
  const { data } = await apiClient.get<Streak>("/streaks/me");
  return data;
}

export async function updateStreakGoal(
  payload: StreakGoalUpdate
): Promise<Streak> {
  const { data } = await apiClient.patch<Streak>("/streaks/me", payload);
  return data;
}
